import * as _ from 'lodash';
import * as utility from "../misc/utility";
import { BaseObject } from "./BaseObject";
import { AuditData } from './Audit';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

/**
 * @typedef {Object} AdjusterNugget
 * @property {number} ClaimType
 * 
 * @typedef {Object} CongestionNugget
 * @property {number} ClaimType
 * @property {number} Congestion
 * 
 * @typedef {Object} LegacyTravelExpenseNugget
 * @property {number} ClaimType
 * @property {string} RouteFrom
 * @property {string} RouteTo
 * @property {number?} DrivingDistance
 * @property {number?} Parking
 * @property {number?} ParkingVat
 * @property {number?} PublicTransport
 * @property {number?} PublicTransportVat
 * @property {number?} Congestion
 * @property {number?} TravelTime
 * 
 * @typedef {Object} LostIncomeAmountNugget
 * @property {number} ClaimType
 * @property {number} Amount
 * @property {string} Employer
 * @property {boolean} RequestRetirementBenefits
 * @property {boolean} RequestVacationBenefits
 * 
 * @typedef {Object} LostIncomeNumberNugget
 * @property {number} ClaimType
 * @property {number} Hours
 * @property {string} Employer
 * @property {boolean} RequestRetirementBenefits
 * @property {boolean} RequestVacationBenefits
 * 
 * @typedef {Object} LostIncomeRateNugget
 * @property {number} ClaimType
 * @property {number} Hours
 * @property {number} HourlyRate
 * @property {string} Employer
 * @property {boolean} RequestRetirementBenefits
 * @property {boolean} RequestVacationBenefits
 * 
 * @typedef {Object} ParkingNugget
 * @property {number} ClaimType
 * @property {number} Parking
 * @property {number?} ParkingVat
 * 
 * @typedef {Object} PublicTransportNugget
 * @property {number} ClaimType
 * @property {number} PublicTransport
 * @property {number?} PublicTransportVat
 * 
 * @typedef {Object} ReceiptExpenseNugget
 * @property {number} ClaimType
 * @property {string} Purpose
 * @property {number} Amount
 * @property {number?} Vat
 * 
 * @typedef {Object} TravelNugget
 * @property {number} ClaimType
 * @property {string} RouteFrom
 * @property {string} RouteTo
 * @property {number} DrivingDistance
 * 
 * @typedef {Object} TravelTimeNugget
 * @property {number} ClaimType
 * @property {number} TravelTime
 * 
 * @typedef {Object} ClaimNugget
 * @property {number} ClaimType
 */

export const claimTypes = Object.freeze({
    legacyTravel: 0,
    expense: 1,
    //lostIncome: 2,
    adjuster: 3,
    travel: 4,
    parking: 5,
    congestion: 6,
    publicTransport: 7,
    travelTime: 8,
    lostIncomeAmount: 9,
    lostIncomeNumber: 10,
    lostIncomeRate: 11
});

export const claimStates = Object.freeze({
    created: 0,
    reported: 1,
    rejected: 2,
    accepted: 3,
});

export class Claim extends BaseObject {
    constructor(src) {
        super();

        if (src) {
            _.assign(this, src);
            /** @type { number } */
            this.ClaimType = src.ClaimType;
            /** @type { ClaimNugget } */
            this.Nugget = src.Nugget;
            this.StateTimestamp = utility.parseDate(this.StateTimestamp);
            this.AuditEntries = _.map(src.AuditEntries, x => new AuditData(x));
        }
    }

    /**
     * @param {ResponseContext} _ctx
     */
    resolve(ctx) {
        _.forEach(this.AuditEntries, x => x.resolve(ctx));
    }
}